module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_03.934484da.jpg";